module.exports = __webpack_public_path__ + "static/media/2011_maleRate_femaleRate.44477979.png";